module.exports = __webpack_public_path__ + "img/paper.c42c83bc.jpg";